export const parameterize = (str: string) => {
  return str
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 -]/, "")
    .replace(/\s/g, "-");
};

export function removeDashes(
  str: string | null | undefined,
): string | null | undefined {
  return str?.replace(/-/g, "").trim();
}

export const searchTerms = (search: string | null | undefined): string[] => {
  return search?.trim().split(/\s+/).filter(Boolean) ?? [];
};
